import base64 from 'base-64'

// Lecture des claims d'un JWT côté client.
//
// Décodage SANS vérification de signature : le back-office ne peut pas
// vérifier un jeton, seule l'API le peut. C'est suffisant ici — il s'agit de
// savoir quand cesser d'envoyer un jeton mort, pas d'accorder un droit.

export const decodeToken = (token: string | null) => {
  if (!token) {
    return null
  }

  try {
    return JSON.parse(base64.decode(token.split('.')[1] ?? '') || '{}')
  } catch (err) {
    return null
  }
}

// `exp` est en secondes (RFC 7519), pas en millisecondes.
export const isExpired = (token: string | null) => {
  const claims = decodeToken(token)

  if (!claims || !claims.exp) {
    return false
  }

  return claims.exp * 1000 <= Date.now()
}

// Un jeton sans `exp` est un jeton d'avant l'introduction des expirations
// (#7512) : immortel, donc à ne plus accepter. Les jetons de cron passés par
// l'URL (rendu PDF) en font partie — d'où l'exception explicite côté
// `restore()`, seul endroit qui les manipule.
export const isImmortal = (token: string | null) => {
  const claims = decodeToken(token)

  return !!claims && !claims.exp
}

export const isUsable = (token: string | null) =>
  !!token && !isExpired(token) && !isImmortal(token)

// --- Appareil de confiance (#7512) ---------------------------------------
//
// Délibérément CONSERVÉ à la déconnexion : c'est l'appareil qui est de
// confiance, pas la session. Se déconnecter puis se reconnecter ne doit pas
// redemander un code. Le jeton est propre au compte côté API : le présenter
// pour un autre compte ne donne rien.

const DEVICE_KEY = '@device'

export const getDeviceToken = () => localStorage.getItem(DEVICE_KEY)

export const rememberDevice = (token: string | null) => {
  if (token) {
    localStorage.setItem(DEVICE_KEY, token)
  }
}
